import gsap from 'gsap';

import Hammer from 'hammerjs';

import Component from '../base/component';
import Common from '../base/common';
import { qs, qsa } from '../base/dom-utils';

class Railway extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.$els.railwayItemsWrap = qs(this.options.wrap, this.$el);
        this.$els.railwayItems = qsa(this.options.item, this.$els.railwayItemsWrap);

        this._hammer = new Hammer(this.$el);
    }

    beforeInit() {

        let railwayWidth = 0,
            currentDragPosition = 0;

        this.$els.railwayItems.forEach((item) => {
            railwayWidth += item.offsetWidth;
        });

        const sliderItemWidth = railwayWidth / this.$els.railwayItems.length;

        if (Common.mq('desktop') && !Modernizr.touchevents) {

            this.delegate('mousemove', this.options.rails, (e) => {
                this.setState('mouseX', e.clientX);
            });

            this.delegate('mouseenter', this.options.rails, () => {

                this._intervalID = setInterval(() => {
                    const speed = this.getSliderSpeed(window.innerWidth, this.getState('mouseX'));
                    const sliderNextXPosition = this.getNextXPosition(speed * 0.5, this.getState('railwayXPosition'), (railwayWidth - sliderItemWidth) * -1);

                    if (speed !== 0) {

                        this.setState('railwayXPosition', sliderNextXPosition);

                        gsap.to(this.$el, 0.2, {
                            x: sliderNextXPosition,
                            ease: Linear.easeNone
                        });
                    }

                }, 200);

            });

            this.delegate('mouseleave', this.options.rails, () => {
                clearInterval(this._intervalID);
            });

        } else if (Common.mqUntil('desktop') && Modernizr.touchevents) {

            this._hammer.on('swipeleft', () => {

                if (currentDragPosition - sliderItemWidth <= -railwayWidth) {
                    return false;
                }

                currentDragPosition -= sliderItemWidth;

                gsap.to(this.$el, 0.5, {
                    x: currentDragPosition
                });


            });

            this._hammer.on('swiperight', () => {

                if (currentDragPosition + sliderItemWidth > 0) {
                    return false;
                }

                currentDragPosition += sliderItemWidth;

                gsap.to(this.$el, 0.5, {
                    x: currentDragPosition
                });

            });

        }



    }

    /**
     * Return the next X position of the slider
     * @param mousePosition
     * @param sliderPosition
     * @param limit
     * @returns {number}
     */
    getNextXPosition(mousePosition, sliderPosition, limit) {
        let result = (sliderPosition + mousePosition) <= 0 ? sliderPosition + mousePosition : 0;
        result = result >= limit ? result : limit;
        return result;
    };

    /**
     * Given the window width and the mouse position returns the value of the slider speed
     * @param windowWidth
     * @param mouseXPosition
     * @returns {number}
     */
    getSliderSpeed(windowWidth, mouseXPosition) {
        const window15 = windowWidth / 5;
        const stopFrom = window15 * 2;
        const stopTo = window15 * 3;
        let result = 0;

        if (mouseXPosition < stopFrom) {
            result = Math.round(this.rangeConversion(mouseXPosition, stopFrom, 0, 0, window15));
        }

        if (mouseXPosition > stopTo) {
            result = Math.round(this.rangeConversion(mouseXPosition, stopTo, windowWidth, 0, window15 * -1));
        }

        return result;
    }

    /**
     * Convert a number range to another range, maintaining ratio
     * @param oldValue
     * @param oldMin
     * @param oldMax
     * @param newMin
     * @param newMax
     * @returns {*}
     */
    rangeConversion(oldValue, oldMin, oldMax, newMin, newMax) {
        // Formula: http://stackoverflow.com/questions/929103/convert-a-number-range-to-another-range-maintaining-ratio
        return (((oldValue - oldMin) * (newMax - newMin)) / (oldMax - oldMin)) + newMin;
    }

    getDefaultOptions() {
        return {
            rails: '#widget-railway',
            wrap: '.c-railway__items',
            item: '.c-railway__item',
            parallaxElements: '[data-speed]'
        }
    }

    getInitialState() {
        return {
            mouseX: 0,
            railwayXPosition: 0
        };
    }

    destroy() {
        this._hammer.off('swipeleft');
        this._hammer.off('swiperight');
        return super.destroy();
    }
}

export default Railway;


/** WEBPACK FOOTER **
 ** ./components/railway.js
 **/